/**
 * @param {String} id filter.p.m.gender
 * @returns {String} f.gender
 */
const shopifyFilterIdToKey = id => {
  const segments = id.split('.');
  return `f.${segments[segments.length - 1]}`;
};

export default shopifyFilterIdToKey;
